define('services/contextService',[
    'lib/lodash4'
],function (
    _
    ) {
    "use strict";

    var isDeskTop;
        /**
         * Utility to check to see if the app is currently in the hosted desktop app context.  This check
         * happens early in the loading of the app and only happens once.
         *
         * This looks for Hosted Context Functions object that indicates this is running in a desktop application.
         */
    return {
            isDeskTop : function(){
                if (_.isUndefined(isDeskTop)){
                    isDeskTop = _.has(window, '_HostedContextFunctions');
                }
                return isDeskTop;
            }
        };

});

